/**
 * Настройки сегментации фона (размытие / виртуальный фон).
 *
 * Модель и wasm-бандл можно менять через .env без пересборки пакета livekit.
 */
/** Модель сегментации MediaPipe. 249 KB, float16, вход 256x256. */
const DEFAULT_MODEL_URL = 'https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite';
/** wasm-бандл @mediapipe/tasks-vision. Версия обязана совпадать с зависимостью @livekit/track-processors. */
const DEFAULT_TASKS_VISION_WASM_URL = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm';
export const BLUR_RADIUS = 24;
const readEnv = (key) => {
    const value = import.meta.env[key];
    return value && value.length > 0 ? value : undefined;
};
/**
 * Пути к ассетам сегментации. По умолчанию — публичные CDN Google и jsDelivr;
 * положив файлы в public/ и задав переменные окружения, их можно раздавать со
 * своего домена (первый кадр появляется быстрее, нет зависимости от внешних CDN).
 */
export const getSegmenterAssetPaths = () => ({
    tasksVisionFileSet: readEnv('VITE_REACT_APP_TASKS_VISION_WASM_URL') ?? DEFAULT_TASKS_VISION_WASM_URL,
    modelAssetPath: readEnv('VITE_REACT_APP_SEGMENTER_MODEL_URL') ?? DEFAULT_MODEL_URL,
});
